import { render, staticRenderFns } from "./MarkContent.vue?vue&type=template&id=6fd5f86a&"
import script from "./MarkContent.vue?vue&type=script&lang=js&"
export * from "./MarkContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports